import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CustomDoubleBannerComponent} from './custom-double-banner.component';
import {CustomCmsItemModule} from '../custom-cms-item/custom-cms-item.module';
import {CmsConfig, ConfigModule} from '@spartacus/core';


@NgModule({
  declarations: [CustomDoubleBannerComponent],
  exports: [CustomDoubleBannerComponent],
  imports: [
    CommonModule,
    CustomCmsItemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        DoubleBannerComponent: {
          component: CustomDoubleBannerComponent,
        },
      },
    } as CmsConfig),
  ]
})
export class CustomDoubleBannerModule { }
